var Admin = Admin || {};
Admin.Metadata = Admin.Metadata || {};

(function(){
	this.changeType = function () {
		var type = $('#metadata-type').val();
		if(type == 'CHECKBOX' || type == 'SELECT'){
			$('.values-field').prop('disabled',false);
    		$('#values-row').show();
    		if($("#values-td input").size() == 0) {
    			Admin.Metadata.addField();
    		}
    		
		} else {
			$('.values-field').prop('disabled',true);
    		$('#values-row').hide();
		}
	}
	
	this.removeLastField = function () {
		var inputs = $("#values-td input");
		var inputCount = inputs.size();
		if(inputCount > 1) {
			inputs[inputCount -1].remove();
		}
	}
	
	this.addField = function () {
		var inputCount = $("#values-td input").size();
 		$("#values-td").append($("<input id='values"+inputCount+"' name='values["+inputCount+"].value' class='values-field' />"));
	}
}).apply(Admin.Metadata);